

export const Loading = () => {
    return (
        <div className="content">Lade Daten...</div>
    )
}
